<ng-container *ngIf="form">
  <form [formGroup]="form" class="flex flex-wrap flex-row items-end justify-between gap-5 fl-filter-container pb-5">
    <div class="flex flex-row flex-wrap gap-5">
      <ng-container *ngFor="let filter of visibleFilters">
        <ng-container
          *ngIf="filter.type === FilterInputType.Text || filter.type === FilterInputType.Number || filter.type === FilterInputType.Email || filter.type === FilterInputType.Password">
          <flow-form-input
            [formControlName]="filter.controlName"
            [label]="filter.label"
            [type]="filter.type"
            [placeholder]="filter.placeholder"
            [required]="filter.required"
            [infoTooltip]="filter.infoTooltip"></flow-form-input>
        </ng-container>

        <ng-container *ngIf="filter.type === FilterInputType.Select">
          <flow-form-select
            [formControlName]="filter.controlName"
            [label]="filter.label"
            [options]="filter.options"
            [multiple]="filter.multiple"
            [isDisabled]="filter.disabled"
            [required]="filter.required"
            [infoTooltip]="filter.infoTooltip"
            [placeholder]="filter.placeholder"
            [selectAll]="filter.selectAll"></flow-form-select>
        </ng-container>

        <div class="flex flex-col" *ngIf="filter.type === FilterInputType.Date">
          <flow-form-date-picker
            [formControlName]="filter.controlName"
            [label]="filter.label"
            [placeholder]="filter.placeholder"
            [required]="filter.required"
            [infoTooltip]="filter.infoTooltip"
            [multiple]="filter.multiple"
            [isDisabled]="filter.disabled"
            [selectAll]="filter.selectAll"
            [dateRangeValidation]="filter.dateRangeValidation"></flow-form-date-picker>
        </div>

        <div class="flex flex-col" *ngIf="filter.type === FilterInputType.DateRange">
          <flow-form-date-range-picker
            [formControlName]="filter.controlName"
            [label]="filter.label"
            [required]="filter.required"
            [infoTooltip]="filter.infoTooltip"
            [isDisabled]="filter.disabled"></flow-form-date-range-picker>
        </div>

        <div class="flex flex-col" *ngIf="filter.type === FilterInputType.WeekRange">
          <flow-form-week-picker
            [formControlName]="filter.controlName"
            [label]="filter.label"
            [required]="filter.required"
            [infoTooltip]="filter.infoTooltip"
            [disableWeekStartDate]="form.get(filter.controlName)?.value?.start"
            class="flex-1"></flow-form-week-picker>
        </div>

        <ng-container *ngIf="filter.type === FilterInputType.Combobox">
          <flow-form-combobox
            [formControlName]="filter.controlName"
            [label]="filter.label"
            [options]="filter.options"
            [multiple]="filter.multiple"
            [isDisabled]="filter.disabled"
            [required]="filter.required"
            [infoTooltip]="filter.infoTooltip"
            [placeholder]="filter.placeholder"
            [selectAll]="filter.selectAll"
            [hasSearch]="true"
            [params]="filter.params"
            [onSearch]="filter.onSearch"
            [onLoadMore]="filter.onLoadMore"></flow-form-combobox>
          </ng-container>

        <div class="flex flex-col self-auto justify-end pb-3" *ngIf="filter.type === FilterInputType.Checkbox">
          <mat-checkbox color="primary" [formControlName]="filter.controlName">{{ filter.label | translate }}</mat-checkbox>
        </div>
      </ng-container>
    </div>

    <div class="flex gap-4 ml-auto items-end">
      <flow-button *ngIf="clearBtn" theme="secondary" variation="outline" [isCapitalize]="false" (onClick)="resetFilters()">
        {{ clearBtnText | translate }}
      </flow-button>
      <flow-button theme="primary" variation="fill" [disabled]="form.invalid" (onClick)="applyFilters()">
        <app-icon fill="none" [stroke]="'#fff'" iconName="file-check-02" size="md"></app-icon>
        <span>{{ submitBtnText | translate }}</span>
      </flow-button>
    </div>
  </form>
</ng-container>

<ng-template #infoTooltip let-filter="filter">
  <app-icon
    *ngIf="filter?.infoTooltip"
    class="cursor-pointer"
    [matTooltip]="filter?.infoTooltip | translate"
    iconName="info"
    size="sm"
    fill="#1f5792"
    matTooltipPosition="above"></app-icon>
</ng-template>
